<template>
  <div :class="$style.wrapper">
    <div :class="$style.info" v-for="item in info" :key="item.id">
      <div :class="$style.icon">
        <img :src="require(`@/assets/icons/${item.icon}`)"/>
      </div>
      <span>{{item.title}}:</span>
      <span :class="{ bold: isBold(value[item.id]) }">{{value[item.id]}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBox',
  props: {
    value: Array,
  },
  data: () => ({
    info: [
      {
        icon: 'picker.svg', title: 'Место', id: 0,
      },
      {
        icon: 'device.svg', title: 'Устройство', id: 1,
      },
      {
        icon: 'speed.svg', title: 'Скорость интернета', id: 2,
      },
      {
        icon: 'notifications.svg', title: 'Уведомления в соцсети', id: 3,
      },
    ],
  }),
  methods: {
    isBold(item) {
      return item === 'Средняя' || item === 'Низкая' || item === 'Отключены'
    },
  },
}
</script>

<style lang="scss" module>
  @import './InfoBox.scss';
</style>
